(function () {
  if (window.__peachFlowerInit) return;
  window.__peachFlowerInit = true;

  var root = document.getElementById('peach-flower-fling');
  if (!root) return;

  var ENDPOINT = root.dataset.endpoint;
  var loggedIn = root.dataset.loggedIn === 'true';
  var customerId = root.dataset.customerId || '';
  var customerName = root.dataset.customerName || '';
  var btn = document.getElementById('peach-flower-btn');

  function showToast(text, ms) {
    var toast = document.createElement('div');
    toast.className = 'peach-flower-toast';
    toast.textContent = text;
    document.body.appendChild(toast);
    requestAnimationFrame(function () { toast.classList.add('peach-flower-toast--visible'); });
    setTimeout(function () {
      toast.classList.remove('peach-flower-toast--visible');
      setTimeout(function () { toast.remove(); }, 400);
    }, ms || 3200);
  }

  function petalBurst(count) {
    var emojis = ['\uD83C\uDF38', '\uD83C\uDF37', '\uD83C\uDF3C', '\uD83C\uDF3A', '\uD83D\uDC90'];
    for (var i = 0; i < count; i++) {
      (function (i) {
        setTimeout(function () {
          var petal = document.createElement('span');
          petal.className = 'peach-flower-petal';
          petal.textContent = emojis[Math.floor(Math.random() * emojis.length)];
          petal.style.left = Math.random() * 100 + 'vw';
          var duration = 3 + Math.random() * 2.5;
          petal.style.animationDuration = duration + 's';
          petal.style.fontSize = (16 + Math.random() * 14) + 'px';
          document.body.appendChild(petal);
          setTimeout(function () { petal.remove(); }, duration * 1000 + 200);
        }, i * 80);
      })(i);
    }
  }

  function showThanksModal() {
    var modal = document.querySelector('.peach-flower-thanks-modal');
    if (!modal) return;
    modal.hidden = false;
    clearTimeout(modal._autoHide);
    modal._autoHide = setTimeout(function () { modal.hidden = true; }, 5000);
  }

  function sendFlower() {
    if (!btn) return;
    btn.disabled = true;
    var original = btn.textContent;
    btn.textContent = 'Sending...';

    fetch(ENDPOINT, {
      method: 'POST',
      mode: 'no-cors',
      body: JSON.stringify({ type: 'flower_send', senderName: customerName, senderCustomerId: customerId })
    }).then(function () {
      btn.textContent = 'Sent';
      petalBurst(26);
      showThanksModal();
      setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 2500);
    }).catch(function () {
      btn.textContent = original;
      btn.disabled = false;
      alert('Something went wrong - please try again.');
    });
  }

  if (btn) {
    btn.addEventListener('click', function () {
      if (loggedIn) {
        sendFlower();
      } else {
        var modal = document.querySelector('.peach-flower-login-modal');
        if (modal) modal.hidden = false;
      }
    });
  }

  document.addEventListener('click', function (e) {
    var closeLogin = e.target.closest('[data-peach-flower-close]');
    if (closeLogin) {
      var loginModal = closeLogin.closest('.peach-flower-login-modal');
      if (loginModal) loginModal.hidden = true;
    }
    var closeThanks = e.target.closest('[data-peach-thanks-close]');
    if (closeThanks) {
      var thanksModal = closeThanks.closest('.peach-flower-thanks-modal');
      if (thanksModal) thanksModal.hidden = true;
    }
  });

  var params = new URLSearchParams(window.location.search);
  if (params.get('send_flowers') === '1') {
    if (loggedIn) sendFlower();
    params.delete('send_flowers');
    var newSearch = params.toString();
    window.history.replaceState({}, '', window.location.pathname + (newSearch ? '?' + newSearch : '') + window.location.hash);
  }

  if (loggedIn && customerId) {
    fetch(ENDPOINT + '?action=checkFlowers&customerId=' + encodeURIComponent(customerId))
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data && data.found) {
          petalBurst(26);
          showToast((data.senderName || 'Someone') + ' sent you flowers!', 4200);
        }
      })
      .catch(function () {});
  }
})();